import { AUTOSAVE_STATUS } from 'hooks/useAutosave';
import React from 'react';
import { Spinner } from 'react-bootstrap';

export default function AutosaveIndicator({ status, errorMessage, onRetry }) {
  switch (status) {
    case AUTOSAVE_STATUS.DIRTY:
      return (
        <span style={{ color: '#d97706', fontSize: '0.875rem', fontWeight: 500 }}>
          ● Alterações não salvas
        </span>
      );

    case AUTOSAVE_STATUS.SAVING:
      return (
        <span
          style={{ color: '#2563eb', fontSize: '0.875rem', fontWeight: 500 }}
          className="d-inline-flex align-items-center"
        >
          <Spinner
            animation="border"
            size="sm"
            className="mr-2"
            style={{ width: '0.9rem', height: '0.9rem' }}
          />
          Salvando...
        </span>
      );

    case AUTOSAVE_STATUS.SAVED:
      return (
        <span style={{ color: '#16a34a', fontSize: '0.875rem', fontWeight: 500 }}>
          ✓ Salvo automaticamente
        </span>
      );

    case AUTOSAVE_STATUS.ERROR:
      return (
        <span
          style={{ color: '#dc2626', fontSize: '0.875rem', fontWeight: 500 }}
          className="d-inline-flex align-items-center"
        >
          ⚠ {errorMessage || 'Não foi possível salvar.'}
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="btn btn-link btn-sm p-0 ml-2"
              style={{ fontSize: '0.85rem', textDecoration: 'underline', color: '#dc2626' }}
            >
              Tentar novamente
            </button>
          )}
        </span>
      );

    case AUTOSAVE_STATUS.IDLE:
    default:
      return null;
  }
}
